// test1325
(1325 && 0);
